// ValutDocu i18n - English + Hindi (top UI strings)
export const STRINGS = {
  en: {
    // Header
    'nav.tools': 'All Tools',
    'nav.ai': 'AI Tools',
    'nav.pricing': 'Pricing',
    'nav.blog': 'Blog',
    'nav.signin': 'Sign in',
    'nav.signup': 'Create account',
    'nav.dashboard': 'Dashboard',
    'nav.signout': 'Sign out',
    // Hero
    'hero.eyebrow': 'The Fort Knox of Documents',
    'hero.title.line1': 'All Document Tools.',
    'hero.title.line2': 'Free. Unlimited.',
    'hero.title.line3': 'Secure.',
    'hero.subtitle':
      'No signups. No watermarks. No file limits. Lock your documents in our vault, process them in seconds, and walk away clean — the iLovePDF you wished for.',
    'hero.cta.start': 'Start Free — No Login',
    'hero.cta.view': 'View All Tools',
    'hero.badge.delete': 'Files deleted in 60 min',
    'hero.badge.ssl': '256-bit SSL encryption',
    'hero.badge.watermarks': 'No watermarks ever',
    'hero.counter.label': 'Live Counter',
    'hero.counter.sub': 'documents processed today',
    'hero.stat.tools': 'Tools',
    'hero.stat.watermarks': 'Watermarks',
    'hero.stat.files': 'Files',
    'hero.stat.delete': 'Auto-delete',
    // Tool grid
    'grid.eyebrow': 'The Toolkit',
    'grid.title.prefix': '37 Tools.',
    'grid.title.suffix': 'Zero Limits.',
    'grid.subtitle':
      "Every document operation you'll ever need — engineered for speed and locked in our vault.",
    'grid.openTool': 'OPEN TOOL',
    'grid.soon': 'Soon',
    // How it works
    'how.eyebrow': 'Process',
    'how.title.prefix': 'Three steps.',
    'how.title.suffix': 'Total privacy.',
    'how.upload.t': 'Upload',
    'how.upload.d': 'Drop your file in the vault over a 256-bit encrypted channel.',
    'how.process.t': 'Process',
    'how.process.d': 'Our optimized Python engine works in isolation — no third parties.',
    'how.download.t': 'Download',
    'how.download.d': 'Grab your file. We delete it from our servers after 60 minutes.',
    // Why us
    'why.eyebrow': 'Why ValutDocu',
    'why.title.prefix': 'Built to beat',
    'why.title.suffix': 'iLovePDF.',
    // CTA
    'cta.title.prefix': 'Your Documents.',
    'cta.title.suffix': 'Secured.',
    'cta.subtitle':
      'No signups required. Drop a file in our vault and walk away — your documents processed and deleted in under an hour.',
    'cta.merge': 'Merge PDFs Now',
    'cta.compress': 'Compress a PDF',
    // Pricing
    'pricing.eyebrow': 'Pricing',
    'pricing.title.prefix': 'Free forever.',
    'pricing.title.suffix': 'Pro when you need it.',
    'pricing.subtitle':
      'ValutDocu is built to be free. Pro unlocks AI tools, no ads, and bigger files — for less than half the cost of iLovePDF.',
    'pricing.free.name': 'Free',
    'pricing.free.tag': 'forever',
    'pricing.free.sub': 'All 33 standard tools. No signup needed.',
    'pricing.free.cta': 'Continue free',
    'pricing.pro.name': 'Pro',
    'pricing.pro.tag': '/month',
    'pricing.pro.trial': '7-day free trial',
    'pricing.pro.cta': 'Start 7-day free trial',
    'pricing.pro.alreadyOn': "You're on Pro",
    // Footer
    'footer.tagline':
      'Your Documents. Secured. Processed. Delivered. The premium online vault for all your PDF & document needs — free, fast, and unrestricted.',
    'footer.copyright': '© {year} ValutDocu — Your Documents. Secured.',
    'footer.privacy': 'Privacy',
    'footer.terms': 'Terms',
    'footer.security': 'Security',
  },
  hi: {
    // Header
    'nav.tools': 'सभी टूल्स',
    'nav.ai': 'AI टूल्स',
    'nav.pricing': 'मूल्य',
    'nav.blog': 'ब्लॉग',
    'nav.signin': 'साइन इन',
    'nav.signup': 'खाता बनाएँ',
    'nav.dashboard': 'डैशबोर्ड',
    'nav.signout': 'साइन आउट',
    // Hero
    'hero.eyebrow': 'दस्तावेज़ों का फोर्ट नॉक्स',
    'hero.title.line1': 'सभी दस्तावेज़ टूल्स।',
    'hero.title.line2': 'मुफ़्त। असीमित।',
    'hero.title.line3': 'सुरक्षित।',
    'hero.subtitle':
      'कोई साइनअप नहीं। कोई वॉटरमार्क नहीं। कोई फ़ाइल सीमा नहीं। अपने दस्तावेज़ों को हमारे वॉल्ट में रखें, सेकंडों में संसाधित करें, और साफ़ निकलें — वही iLovePDF जो आप चाहते थे।',
    'hero.cta.start': 'मुफ़्त शुरू करें — बिना लॉगिन',
    'hero.cta.view': 'सभी टूल देखें',
    'hero.badge.delete': '60 मिनट में फ़ाइलें हटाई गईं',
    'hero.badge.ssl': '256-बिट SSL एन्क्रिप्शन',
    'hero.badge.watermarks': 'कभी कोई वॉटरमार्क नहीं',
    'hero.counter.label': 'लाइव काउंटर',
    'hero.counter.sub': 'आज प्रसंस्कृत दस्तावेज़',
    'hero.stat.tools': 'टूल्स',
    'hero.stat.watermarks': 'वॉटरमार्क',
    'hero.stat.files': 'फ़ाइलें',
    'hero.stat.delete': 'ऑटो-डिलीट',
    // Tool grid
    'grid.eyebrow': 'टूलकिट',
    'grid.title.prefix': '37 टूल्स।',
    'grid.title.suffix': 'कोई सीमा नहीं।',
    'grid.subtitle':
      'हर दस्तावेज़ ऑपरेशन जिसकी आपको कभी ज़रूरत होगी — गति के लिए डिज़ाइन और हमारे वॉल्ट में सुरक्षित।',
    'grid.openTool': 'टूल खोलें',
    'grid.soon': 'जल्द',
    // How it works
    'how.eyebrow': 'प्रक्रिया',
    'how.title.prefix': 'तीन चरण।',
    'how.title.suffix': 'पूर्ण गोपनीयता।',
    'how.upload.t': 'अपलोड',
    'how.upload.d': '256-बिट एन्क्रिप्टेड चैनल पर अपनी फ़ाइल वॉल्ट में डालें।',
    'how.process.t': 'प्रोसेस',
    'how.process.d': 'हमारा अनुकूलित Python इंजन एकाकी में काम करता है — कोई तीसरा पक्ष नहीं।',
    'how.download.t': 'डाउनलोड',
    'how.download.d': 'अपनी फ़ाइल लें। हम इसे 60 मिनट बाद अपने सर्वर से हटा देते हैं।',
    // Why us
    'why.eyebrow': 'क्यों ValutDocu',
    'why.title.prefix': 'iLovePDF को',
    'why.title.suffix': 'मात देने के लिए।',
    // CTA
    'cta.title.prefix': 'आपके दस्तावेज़।',
    'cta.title.suffix': 'सुरक्षित।',
    'cta.subtitle':
      'कोई साइनअप आवश्यक नहीं। हमारे वॉल्ट में एक फ़ाइल डालें और चलें — आपके दस्तावेज़ एक घंटे के भीतर संसाधित और हटा दिए गए।',
    'cta.merge': 'अभी PDF मर्ज करें',
    'cta.compress': 'PDF कंप्रेस करें',
    // Pricing
    'pricing.eyebrow': 'मूल्य',
    'pricing.title.prefix': 'हमेशा मुफ़्त।',
    'pricing.title.suffix': 'Pro जब आपको ज़रूरत हो।',
    'pricing.subtitle':
      'ValutDocu मुफ़्त बनाया गया है। Pro AI टूल्स, बिना विज्ञापन और बड़ी फ़ाइलें अनलॉक करता है — iLovePDF की आधी से कम कीमत पर।',
    'pricing.free.name': 'मुफ़्त',
    'pricing.free.tag': 'हमेशा',
    'pricing.free.sub': 'सभी 33 मानक टूल। साइनअप की ज़रूरत नहीं।',
    'pricing.free.cta': 'मुफ़्त जारी रखें',
    'pricing.pro.name': 'प्रो',
    'pricing.pro.tag': '/महीना',
    'pricing.pro.trial': '7-दिन का मुफ़्त ट्रायल',
    'pricing.pro.cta': '7-दिन का मुफ़्त ट्रायल शुरू करें',
    'pricing.pro.alreadyOn': 'आप Pro पर हैं',
    // Footer
    'footer.tagline':
      'आपके दस्तावेज़। सुरक्षित। प्रसंस्कृत। वितरित। आपकी सभी PDF और दस्तावेज़ ज़रूरतों के लिए प्रीमियम ऑनलाइन वॉल्ट — मुफ़्त, तेज़, और असीमित।',
    'footer.copyright': '© {year} ValutDocu — आपके दस्तावेज़। सुरक्षित।',
    'footer.privacy': 'गोपनीयता',
    'footer.terms': 'शर्तें',
    'footer.security': 'सुरक्षा',
  },
};
